import React from 'react';
import MainSlider from "../components/MainSlider";
import Banner from "../components/Banner";
import MainProduct from "../components/MainProduct";
import {Helmet} from "react-helmet";

const Index = () => {
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Главная - Holz-City</title>
                <meta
                    name="description"
                    content="Высококачественные пиломатериалы для строительства, отделки и ремонта."
                />
            </Helmet>
            <MainSlider/>
            <Banner/>
            <MainProduct/>
        </div>
    );
};

export default Index;